import React from 'react';

import classNames from 'classnames';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

interface Translations {
	clickableText: string;
	beforeClickableText: string;
	afterClickableText: string;
}

interface Props {
	translations: Translations;
	onClickSwitch: () => void;
	onToggle: (isOpen: boolean) => void;
	isOpen: boolean;
	blockedSwitching?: boolean;
	elementId: string;
}

const SoftRolloutBar: React.FC<Props> = ({
	translations,
	onClickSwitch,
	onToggle,
	isOpen,
	blockedSwitching,
	elementId
}) => {
	const open = () => onToggle(true);
	const close = () => onToggle(false);

	return (
		<div className="soft-rollout-bar-container">
			<div className={classNames('soft-rollout-bar', { 'hide-rollout-bar': !isOpen })}>
				<div className="soft-rollout-bar-content">
					<span className="soft-rollout-bar-close-icon" onClick={close}>
						<BringgIcon iconName={BringgFontIcons.Close} className="icon" />
					</span>
					&nbsp;
					<span>{translations.beforeClickableText}</span>
					{!blockedSwitching && (
						<>
							&nbsp;
							<span id={elementId} className="clickable-content" onClick={onClickSwitch}>
								{translations.clickableText}
							</span>
							&nbsp;
							<span>{translations.afterClickableText}</span>
						</>
					)}
				</div>
			</div>

			<div className={classNames('rollout-bar-closed', { 'hide-rollout-bar': isOpen })} onClick={open}>
				<div className="rollout-bar-closed-icon">
					<BringgIcon iconName={BringgFontIcons.Info} />
				</div>
			</div>
		</div>
	);
};

export default SoftRolloutBar;
